import styled, { css, keyframes } from 'styled-components';

const pulse = keyframes`
  0% { opacity: 1; }
  50% { opacity: 0.4; }
  100% { opacity: 1; }
`;

export const LiveBar = styled.div(
  ({ theme: { palette } }) => css`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 10px 16px;
    background-color: ${palette.common.white};
    border: 1px solid ${palette.chart.grid};
    border-radius: 8px;
  `,
);

export const LiveDot = styled.span(
  ({ theme: { palette } }) => css`
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: ${palette.chart.ok};

    &::before {
      content: '';
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: ${palette.chart.ok};
      animation: ${pulse} 1.5s ease-in-out infinite;
    }
  `,
);

export const LiveHint = styled.span(
  ({ theme: { palette } }) => css`
    color: ${palette.info.main};
  `,
);

export const Spacer = styled.div`
  flex-grow: 1;
`;

export const FilterRow = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  align-items: flex-start;
`;

export const FilterField = styled.div`
  min-width: 200px;
`;

/**
 * Verbatim wire content, so it keeps a monospaced face and its own line breaks. This is the frame's
 * own typography, not the details panel's: the labels and values around it are the application's
 * `DetailName` / `DetailText`.
 */
export const FrameBlock = styled.pre(
  ({ theme: { palette } }) => css`
    margin: 0;
    padding: 10px 12px;
    background-color: ${palette.grey[100]};
    border: 1px solid ${palette.chart.grid};
    border-radius: 6px;
    font-family: 'JetBrains Mono', ui-monospace, Menlo, monospace;
    font-size: 12px;
    white-space: pre-wrap;
    word-break: break-word;
  `,
);
